import { render, staticRenderFns } from "./NotificationSupportMiddleSchool.vue?vue&type=template&id=b1de17f0&scoped=true"
import script from "./NotificationSupportMiddleSchool.vue?vue&type=script&lang=js"
export * from "./NotificationSupportMiddleSchool.vue?vue&type=script&lang=js"
import style0 from "./NotificationSupportMiddleSchool.vue?vue&type=style&index=0&id=b1de17f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1de17f0",
  null
  
)

export default component.exports